import { Typography, Button, Stack } from '@mui/material';
import { Link } from '@remix-run/react';
import { Lock } from 'icons';

import BackHomeButton from './BackHomeButton';
import ErrorLayout from './ErrorLayout';

const MessageLineOne = () => (
  <Typography variant="h4">{`You don't have access to this page.`}</Typography>
);

const Page403 = () => {
  return (
    <ErrorLayout
      MessageLineOne={MessageLineOne}
      MessageLineTwo={BackHomeButton}
      Alert={Lock}
    />
  );
};

export default Page403;
